import React, { Component } from "react";
import { Row, Col, Card, Form } from "reactstrap";
import CgnTextbox from "../toolbox/CgnTextbox";
import CgnAlert from "../toolbox/CgnAlert";
import CgnButtonGroup from "../toolbox/CgnButtonGroup";
import CgnLoader from "../toolbox/CgnLoader";
import CgnMessage from "../toolbox/CgnMessage";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {
  URL,
  resizeFile,
  fotoStyle,
  textAreaStyle,
  
  Day,
} from "../../redux/actions/constants";
import ImageUpload from "../toolbox/CgnImageUpload";
import noFotoMember from "../../images/no-img.png";
import { CgnEMailControl } from "../toolbox/CgnEMailControl";
import { CgnPhoneControl } from "../toolbox/CgnPhoneControl";
import { CgnTaxNoControl } from "../toolbox/CgnTaxNoControl";
import CgnReactSelect from "../toolbox/CgnReactSelect";
import { confirmAlert } from "react-confirm-alert";

class CompanyInfoUpdate extends Component {
  state = {
    pageTitle: "Firma Bilgilerini Güncelle",
    breadcrumb: [{ text: "Firma Bilgilerini Güncelle", link: "#" }],
    isLoading: false,
    guid: "",
    name: "",
    taxNo: "",
    taxAdministration: "",
    address: "",
    phone: "",
    fax: "",
    eMail: "",
    website: "",
    logo: "",
    logoName: "",
    icon: "",
    iconName: "",
    stamp: "",
    stampName: "",
    districtGuid: "00000000-0000-0000-0000-000000000000",
    townGuid: "00000000-0000-0000-0000-000000000000",
    cityGuid: "00000000-0000-0000-0000-000000000000",
    countryGuid: "",
    countryName: "",
    isCityTrue: true,
    isDistrictTrue: true,
    isTownTrue: true,
    labelIsTurkey: false,
    zipCode: "",
    messagePort: "",
    remindDay: null,
    messageHost: "",
    messageEMail: "",
    messagePassword: "",
    gsm: "",
    whatsapp: "",
    facebook: "",
    twitter: "",
    instagram: "",
    youtube: "",
    isDeleted: false,
    status: false,
    createdBy: 0,
    createdAt: "",
    updatedBy: 0,
    updatedAt: "",
    nameError: "",
    taxNoError: "",
    taxAdministrationError: "",
    addressError: "",
    phoneError: "",
    eMailError: "",
    messagePortError: "",
    messageHostError: "",
    messageEMailError: "",
    alertErrorMessage: "",
    buttons: [
      {
        type: "button",
        color: "secondary",
        text: CgnMessage.clearButton,
        onClick: (event) => this.handleClear(event),
        disabled: this.isLoading,
      },
      {
        type: "submit",
        color: "primary",
        text: CgnMessage.saveButton,
        disabled: this.isLoading,
      },
    ],
  };

  async componentDidMount() {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    await axios
      .get(URL + "/countries/getlist", config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: item.name,
          };
        });
        this.setState({
          countryArr: myArr,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
    await axios
      .get(URL + "/companies/get", config)
      .then((response) => {
        this.setState({
          name: response.data.name,
          taxNo: response.data.taxNo,
          taxAdministration: response.data.taxAdministration,
          address: response.data.address,
          phone: response.data.phone,
          fax: response.data.fax,
          eMail: response.data.eMail,
          website: response.data.website,
          logo: response.data.logo,
          logo2: response.data.logo2,
          icon: response.data.icon,
          stamp: response.data.stamp,
          districtGuid: response.data.districtGuid,
          townGuid: response.data.townGuid,
          cityGuid: response.data.cityGuid,
          countryGuid: response.data.countryGuid,
          countryName: response.data.countryName,
          zipCode: response.data.zipCode,
          status: response.data.status,
          messagePort: response.data.messagePort,
          messageHost: response.data.messageHost,
          messageEMail: response.data.messageEMail,
          gsm: response.data.gsm,
          whatsapp: response.data.whatsapp,
          facebook: response.data.facebook,
          twitter: response.data.twitter,
          instagram: response.data.instagram,
          youtube: response.data.youtube,
          isDeleted: response.data.isDeleted,
          createdBy: response.data.createdBy,
          createdAt: response.data.createdAt,
          updatedBy: response.data.updatedBy,
          updatedAt: response.data.updatedAt,
          guid: response.data.guid,
          remindDay: response.data.remindDay,
          isLoading: false,
        });
        if (this.state.cityGuid) {
          axios
            .get(URL + "/cities/getlist/" + this.state.countryGuid, config)
            .then((response) => {
              var myArr = response.data.map(function (item) {
                return {
                  value: item.guid,
                  label: item.name,
                };
              });
              this.setState({
                cityArr: myArr,
              });
            })
            .catch((error) => {
              this.setState({
                alertErrorMessage: error.response.data,
                isLoading: false,
              });
            });
        }
        if (this.state.townGuid) {
          axios
            .get(URL + "/towns/getlist/" + this.state.cityGuid, config)
            .then((response) => {
              var myArr = response.data.map(function (item) {
                return {
                  value: item.guid,
                  label: item.name,
                };
              });
              this.setState({
                townArr: myArr,
              });
            })
            .catch((error) => {
              this.setState({
                alertErrorMessage: error.response.data,
                isLoading: false,
              });
            });
        }
        if (this.state.districtGuid) {
          axios
            .get(URL + "/districts/getlist/" + this.state.townGuid, config)
            .then((response) => {
              var myArr = response.data.map(function (item) {
                return {
                  value: item.guid,
                  label: item.name,
                };
              });
              this.setState({
                districtArr: myArr,
                isLoading: false,
              });
            })
            .catch((error) => {
              this.setState({
                alertErrorMessage: error.response.data,
                isLoading: false,
              });
            });
        }
        if (this.state.countryName === "TÜRKİYE") {
          this.setState({
            isCityTrue: false,
            isTownTrue: false,
            isDistrictTrue: false,
            labelIsTurkey: true,
          });
        }
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
    this.setState({
      nameError: "",
      taxNoError: "",
      taxAdministrationError: "",
      addressError: "",
      phoneError: "",
      eMailError: "",
      messagePortError: "",
      messageHostError: "",
      messageEMailError: "",
      alertErrorMessage: "",
    });
    if (name === "name" && value === "") {
      this.setState({
        nameError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "taxNo" && value === "") {
      this.setState({
        taxNoError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "taxNo" && value !== "" && !CgnTaxNoControl.test(value)) {
      this.setState({
        taxNoError: CgnMessage.taxNoErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "taxAdministration" && value === "") {
      this.setState({
        taxAdministrationError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "address" && value === "") {
      this.setState({
        addressError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "eMail" && value === "") {
      this.setState({
        eMailError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "phone" && value === "") {
      this.setState({
        phoneError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "phone" && value !== "" && !CgnPhoneControl.test(value)) {
      this.setState({
        phoneError: CgnMessage.phoneErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "eMail" && value !== "" && !CgnEMailControl.test(value)) {
      this.setState({
        eMailError: CgnMessage.emailErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "messagePort" && value === "") {
      this.setState({
        messagePortError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "messageHost" && value === "") {
      this.setState({
        messageHostError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (name === "messageEMail" && value === "") {
      this.setState({
        messageEMailError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  };

  handleDayChange(option) {
    if (option) {
      this.setState({
        remindDay: option.value,
      });
    } else {
      this.setState({
        remindDay: null,
      });
    }
  }

  handleSave = async (event) => {
    event.preventDefault();
    this.setState({
      nameError: "",
      taxNoError: "",
      taxAdministrationError: "",
      addressError: "",
      phoneError: "",
      eMailError: "",
      districtError: "",
      townError: "",
      cityError: "",
      countryError: "",
      messagePortError: "",
      messageHostError: "",
      messageEMailError: "",
      alertErrorMessage: "",
    });
    if (this.state.name === "") {
      this.setState({
        nameError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.taxNo === "") {
      this.setState({
        taxNoError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.taxNo !== "" && !CgnTaxNoControl.test(this.state.taxNo)) {
      this.setState({
        taxNoError: CgnMessage.taxNoErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.taxAdministration === "") {
      this.setState({
        taxAdministrationError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.address === "") {
      this.setState({
        addressError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.countryGuid === "") {
      this.setState({
        countryError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (
      this.state.labelIsTurkey === true &&
      this.state.cityGuid === "00000000-0000-0000-0000-000000000000"
    ) {
      this.setState({
        cityError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (
      this.state.labelIsTurkey === true &&
      this.state.cityGuid !== "00000000-0000-0000-0000-000000000000" &&
      this.state.townGuid === "00000000-0000-0000-0000-000000000000"
    ) {
      this.setState({
        townError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (
      this.state.labelIsTurkey === true &&
      this.state.townGuid !== "00000000-0000-0000-0000-000000000000" &&
      this.state.districtGuid === "00000000-0000-0000-0000-000000000000"
    ) {
      this.setState({
        districtError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.phone === "") {
      this.setState({
        phoneError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.phone !== "" && !CgnPhoneControl.test(this.state.phone)) {
      this.setState({
        phoneError: CgnMessage.phoneErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.eMail === "") {
      this.setState({
        eMailError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.eMail !== "" && !CgnEMailControl.test(this.state.eMail)) {
      this.setState({
        eMailError: CgnMessage.emailErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.messagePort === "") {
      this.setState({
        messagePortError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.messageHost === "") {
      this.setState({
        messageHostError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.messageEMail === "") {
      this.setState({
        messageEMailError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    } else if (
      this.state.name !== "" &&
      this.state.address !== "" &&
      ((this.state.labelIsTurkey === true &&
        this.state.countryGuid &&
        this.state.cityGuid &&
        this.state.cityGuid !== "00000000-0000-0000-0000-000000000000" &&
        this.state.townGuid &&
        this.state.townGuid !== "00000000-0000-0000-0000-000000000000" &&
        this.state.districtGuid &&
        this.state.districtGuid !== "00000000-0000-0000-0000-000000000000") ||
        (this.state.labelIsTurkey === false && this.state.countryGuid)) &&
      this.state.taxNo !== "" &&
      CgnTaxNoControl.test(this.state.taxNo) &&
      this.state.phone !== "" &&
      CgnPhoneControl.test(this.state.phone) &&
      this.state.taxAdministration !== "" &&
      this.state.phone !== "" &&
      this.state.eMail !== "" &&
      this.state.messagePort !== "" &&
      this.state.messageHost !== "" &&
      this.state.messageEMail !== ""
    ) {
      this.setState({
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      var myObj = {
        name: this.state.name,
        taxNo: this.state.taxNo,
        taxAdministration: this.state.taxAdministration,
        address: this.state.address,
        phone: this.state.phone,
        eMail: this.state.eMail,
        website: this.state.website,
        fax: this.state.fax,
        logo: this.state.logo,
        logo2: this.state.logo2,
        icon: this.state.icon,
        stamp: this.state.stamp,
        status: this.state.status,
        countryGuid: this.state.countryGuid,
        cityGuid: this.state.cityGuid,
        districtGuid: this.state.districtGuid,
        townGuid: this.state.townGuid,
        zipCode: this.state.zipCode,
        messagePort: parseInt(this.state.messagePort),
        messageHost: this.state.messageHost,
        messageEMail: this.state.messageEMail,
        messagePassword: this.state.messagePassword,
        gsm: this.state.gsm,
        whatsapp: this.state.whatsapp,
        facebook: this.state.facebook,
        twitter: this.state.twitter,
        instagram: this.state.instagram,
        youtube: this.state.youtube,
        isDeleted: this.state.isDeleted,
        createdBy: this.state.createdBy,
        createdAt: this.state.createdAt,
        updatedBy: this.state.updatedBy,
        updatedAt: this.state.updatedAt,
        guid: this.state.guid,
        remindDay: this.state.remindDay,
      };
      axios
        .post(URL + "/companies/updatecompany", myObj, config)
        .then(() => {
          confirmAlert({
            title: CgnMessage.alertSuccessTitle,
            message: CgnMessage.updateSuccessMessage,
            buttons: [
              {
                label: CgnMessage.closeButton,
                onClick: () => {
                  window.location.reload();
                }
              },
            ],
          });
        })
        .catch((error) => {
          confirmAlert({
            title: CgnMessage.alertErrorTitle,
            message: error.response.data,
            buttons: [
              {
                label: CgnMessage.closeButton,
                onClick: () => {
                  this.setState({
                    isLoading: false,
                  });
                }
              },
            ],
          });
        });
    }
  };

  uploadedImage = async (event) => {
    const file = event.target.files[0];
    const logo = await resizeFile(file, 1000);
    await this.setState({
      logo: logo,
      logoName: event.target.files[0].name,
      alertErrorMessage: "",
    });
  };

  deleteImage = async (e) => {
    await this.setState({
      logo: "",
      logoName: "",
    });
  };

  uploadedImage2 = async (event) => {
    const file = event.target.files[0];
    const logo2 = await resizeFile(file, 1000);
    await this.setState({
      logo2: logo2,
      logo2Name: event.target.files[0].name,
      alertErrorMessage: "",
    });
  };

  deleteImage2 = async (e) => {
    await this.setState({
      logo2: "",
      logo2Name: "",
    });
  };

  uploadedIcon = async (event) => {
    const file = event.target.files[0];
    const icon = await resizeFile(file, 1000);
    this.setState({
      icon: icon,
      iconName: event.target.files[0].name,
      alertErrorMessage: "",
    });
  };

  deleteIcon = async (event) => {
    this.setState({
      icon: "",
      iconName: "",
    });
  };

  uploadedStamp = async (event) => {
    const file = event.target.files[0];
    const stamp = await resizeFile(file, 1000);
    this.setState({
      stamp: stamp,
      stampName: event.target.files[0].name,
      alertErrorMessage: "",
    });
  };

  deleteStamp = async (event) => {
    this.setState({
      stamp: "",
      stampName: "",
    });
  };

  handleClear = (event) => {
    this.clearPage();
  };

  clearPage() {
    this.setState({
      name: "",
      taxNo: "",
      taxAdministration: "",
      address: "",
      phone: "",
      eMail: "",
      website: "",
      logo: "",
      logoName: "",
      logo2: "",
      logo2Name: "",
      icon: "",
      iconName: "",
      stamp: "",
      stampName: "",
      nameError: CgnMessage.textErrorMessage,
      taxNoError: CgnMessage.textErrorMessage,
      taxAdministrationError: CgnMessage.textErrorMessage,
      addressError: CgnMessage.textErrorMessage,
      phoneError: CgnMessage.textErrorMessage,
      eMailError: CgnMessage.textErrorMessage,
      alertErrorMessage: CgnMessage.alertErrorMessage,
    });
  }

  async handleCountrySelectChange(option) {
    this.setState({
      isLoading: true,
    });
    if (option) {
      await this.setState({
        countryGuid: option.value,
        isCityTrue: false,
        countryError: "",
        alertErrorMessage: "",
      });
      if (option.label === "TÜRKİYE") {
        this.setState({
          labelIsTurkey: true,
        });
      }
      if (option.label !== "TÜRKİYE") {
        this.setState({
          isCityTrue: true,
          isTownTrue: true,
          isDistrictTrue: true,
          labelIsTurkey: false,
          isLoading: false,
          cityGuid: "00000000-0000-0000-0000-000000000000",
          townGuid: "00000000-0000-0000-0000-000000000000",
          districtGuid: "00000000-0000-0000-0000-000000000000",
          cityError: "",
          townError: "",
          districtError: "",
        });
      }
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      await axios
        .get(URL + "/cities/getlist/" + option.value, config)
        .then((response) => {
          var myArr = response.data.map(function (item) {
            return {
              value: item.guid,
              label: item.name,
            };
          });
          this.setState({
            cityArr: myArr,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        countryGuid: "",
        isCityTrue: true,
        isTownTrue: true,
        isDistrictTrue: true,
        isLoading: false,
        cityGuid: "00000000-0000-0000-0000-000000000000",
        townGuid: "00000000-0000-0000-0000-000000000000",
        districtGuid: "00000000-0000-0000-0000-000000000000",
        cityError: "",
        townError: "",
        districtError: "",
        countryError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  async handleCitySelectChange(option) {
    this.setState({
      isLoading: true,
    });
    if (option) {
      await this.setState({
        cityGuid: option.value,
        isTownTrue: false,
        cityError: "",
        alertErrorMessage: "",
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      await axios
        .get(URL + "/towns/getlist/" + option.value, config)
        .then((response) => {
          var myArr = response.data.map(function (item) {
            return {
              value: item.guid,
              label: item.name,
            };
          });
          this.setState({
            townArr: myArr,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        cityGuid: "",
        isTownTrue: true,
        isDistrictTrue: true,
        isLoading: false,
        townGuid: "00000000-0000-0000-0000-000000000000",
        districtGuid: "00000000-0000-0000-0000-000000000000",
        townError: "",
        districtError: "",
        cityError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  async handleTownSelectChange(option) {
    this.setState({
      isLoading: true,
    });
    if (option) {
      this.setState({
        townGuid: option.value,
        isDistrictTrue: false,
        townError: "",
        alertErrorMessage: "",
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      await axios
        .get(URL + "/districts/getlist/" + option.value, config)
        .then((response) => {
          var myArr = response.data.map(function (item) {
            return {
              value: item.guid,
              label: item.name,
            };
          });
          this.setState({
            districtArr: myArr,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        townGuid: "",
        isDistrictTrue: true,
        districtGuid: "00000000-0000-0000-0000-000000000000",
        districtError: "",
        isLoading: false,
        townError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  async handleDistrictSelectChange(option) {
    if (option) {
      this.setState({
        districtGuid: option.value,
        districtError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        districtGuid: "00000000-0000-0000-0000-000000000000",
        districtError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  render() {
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
        />
        <Row>
          <Col>
            <Form onSubmit={this.handleSave}>
              <Card body>
                <CgnLoader visibled={this.state.isLoading} />

                <h2 className="d-block mb-3">Firma Bilgileri</h2>

                <Row>
                  <Col lg="2">
                    <ImageUpload
                      accept="image/png, image/jpeg"
                      className="text-center"
                      style={fotoStyle}
                      label="Logo"
                      name="logo"
                      image={this.state.logo}
                      noFoto={noFotoMember}
                      alt={this.state.name}
                      onChange={this.uploadedImage}
                      onDelete={this.deleteImage}
                    />
                  </Col>
                  <Col lg="2">
                    <ImageUpload
                      accept="image/png, image/jpeg"
                      className="text-center"
                      style={fotoStyle}
                      label="Logo 2"
                      name="logo2"
                      image={this.state.logo2}
                      noFoto={noFotoMember}
                      alt={this.state.name}
                      onChange={this.uploadedImage2}
                      onDelete={this.deleteImage2}
                    />
                  </Col>
                  <Col lg="2">
                    <ImageUpload
                      className="text-center"
                      style={fotoStyle}
                      label="İkon"
                      name="icon"
                      image={this.state.icon}
                      noFoto={noFotoMember}
                      alt={this.state.name}
                      onChange={this.uploadedIcon}
                      onDelete={this.deleteIcon}
                    />
                  </Col>
                  <Col lg="2">
                    <ImageUpload
                      className="text-center"
                      style={fotoStyle}
                      label="Kaşe / İmza"
                      name="stamp"
                      image={this.state.stamp}
                      noFoto={noFotoMember}
                      alt={this.state.name}
                      onChange={this.uploadedStamp}
                      onDelete={this.deleteStamp}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg="4">
                    <CgnTextbox
                      type="text"
                      name="name"
                      label="Ad [*]"
                      value={this.state.name}
                      placeHolder="Lütfen firma adı girin..."
                      maxLength="200"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.nameError}
                    />
                  </Col>
                  <Col lg="4">
                    <CgnTextbox
                      type="text"
                      name="taxAdministration"
                      label="Vergi Dairesi [*]"
                      value={this.state.taxAdministration}
                      placeHolder="Lütfen firma vergi dairesi girin..."
                      maxLength="100"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.taxAdministrationError}
                    />
                  </Col>

                  <Col lg="4">
                    <CgnTextbox
                      type="text"
                      name="taxNo"
                      maxLength="11"
                      label="Vergi Numarası [*]"
                      value={this.state.taxNo}
                      placeHolder="Lütfen firma vergi numarası girin..."
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.taxNoError}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg="12">
                    <CgnTextbox
                      inlineStyle={textAreaStyle}
                      type="textarea"
                      name="address"
                      label="Adres [*]"
                      value={this.state.address}
                      placeHolder="Lütfen adres girin..."
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.addressError}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg="3">
                    <CgnReactSelect
                      name="countryGuid"
                      label="Ülke [*]"
                      placeholder="Lütfen ülke seçiniz..."
                      selectValue={this.state.countryGuid}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) =>
                        this.handleCountrySelectChange(option)
                      }
                      options={this.state.countryArr}
                      error={this.state.countryError}
                    />
                  </Col>

                  <Col lg="3">
                    <CgnReactSelect
                      name="cityGuid"
                      label="Şehir [*]"
                      placeholder="Lütfen şehir seçiniz..."
                      selectValue={this.state.cityGuid}
                      isMulti={false}
                      isClearable={true}
                      disabled={this.state.isCityTrue}
                      onChange={(option) => this.handleCitySelectChange(option)}
                      options={this.state.cityArr}
                      error={this.state.cityError}
                    />
                  </Col>

                  <Col lg="3">
                    <CgnReactSelect
                      name="townGuid"
                      label="İlçe [*]"
                      placeholder="Lütfen ilçe seçiniz..."
                      selectValue={this.state.townGuid}
                      isMulti={false}
                      isClearable={true}
                      disabled={this.state.isTownTrue}
                      onChange={(option) => this.handleTownSelectChange(option)}
                      options={this.state.townArr}
                      error={this.state.townError}
                    />
                  </Col>

                  <Col lg="3">
                    <CgnReactSelect
                      name="districtGuid"
                      label="Mahalle [*]"
                      placeholder="Lütfen mahalle seçiniz..."
                      selectValue={this.state.districtGuid}
                      isMulti={false}
                      isClearable={true}
                      disabled={this.state.isDistrictTrue}
                      onChange={(option) =>
                        this.handleDistrictSelectChange(option)
                      }
                      options={this.state.districtArr}
                      error={this.state.districtError}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="zipCode"
                      label="Posta Kodu"
                      value={this.state.zipCode}
                      placeHolder="Lütfen posta kodu girin..."
                      maxLength="100"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.zipCodeError}
                    />
                  </Col>

                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="eMail"
                      label="E-Mail [*]"
                      value={this.state.eMail}
                      placeHolder="Lütfen firma email girin..."
                      maxLength="225"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.eMailError}
                    />
                  </Col>
                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="website"
                      label="Web Adresi"
                      value={this.state.website}
                      placeHolder="Lütfen firma web adresini girin..."
                      maxLength="100"
                      autoComplete="off"
                      onChange={this.handleChange}
                    />
                  </Col>
                  <Col lg="2">
                    <CgnReactSelect
                      name="remindDay"
                      label="Hatırlatma Günü"
                      placeholder="Lütfen gün seçiniz..."
                      selectValue={this.state.remindDay}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) => this.handleDayChange(option)}
                      options={Day}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="phone"
                      label="Telefon [*]"
                      value={this.state.phone}
                      placeHolder="0xxxxxxxxxx"
                      maxLength="11"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.phoneError}
                    />
                  </Col>

                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="fax"
                      label="Faks"
                      value={this.state.fax}
                      placeHolder="0xxxxxxxxxx"
                      maxLength="11"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.faxError}
                    />
                  </Col>

                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="gsm"
                      label="GSM"
                      value={this.state.gsm}
                      placeHolder="0xxxxxxxxxx"
                      maxLength="11"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.gsmError}
                    />
                  </Col>

                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="whatsapp"
                      label="Whatsapp"
                      value={this.state.whatsapp}
                      placeHolder="0xxxxxxxxxx"
                      maxLength="11"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.whatsappError}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="facebook"
                      label="Facebook"
                      value={this.state.facebook}
                      placeHolder="Lütfen facebook adresi girin..."
                      maxLength="500"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.facebookError}
                    />
                  </Col>

                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="twitter"
                      label="Twitter"
                      value={this.state.twitter}
                      placeHolder="Lütfen twitter adresi girin..."
                      maxLength="500"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.twitterError}
                    />
                  </Col>

                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="instagram"
                      label="Instagram"
                      value={this.state.instagram}
                      placeHolder="Lütfen instagram adresi girin..."
                      maxLength="500"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.instagramError}
                    />
                  </Col>

                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="youtube"
                      label="Youtube"
                      value={this.state.youtube}
                      placeHolder="Lütfen youtube adresi girin..."
                      maxLength="500"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.youtubeError}
                    />
                  </Col>
                </Row>

                <h2 className="d-block mb-3">E-Mail Ayarları</h2>

                <Row>
                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="messageHost"
                      label="Giden Posta Sunucusu Adresi [*]"
                      value={this.state.messageHost}
                      placeHolder="Lütfen giden posta sunucusu adresi girin..."
                      maxLength="100"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.messageHostError}
                    />
                  </Col>

                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="messagePort"
                      maxLength="10"
                      label="Giden Posta Sunucu Portu [*]"
                      value={this.state.messagePort}
                      placeHolder="Lütfen giden sunucu portu girin..."
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.messagePortError}
                    />
                  </Col>
                  <Col lg="3">
                    <CgnTextbox
                      type="text"
                      name="messageEMail"
                      label="Gönderen E-Mail [*]"
                      value={this.state.messageEMail}
                      placeHolder="Lütfen gönderen e-mail girin..."
                      maxLength="255"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.messageEMailError}
                    />
                  </Col>

                  <Col lg="3">
                    <CgnTextbox
                      type="password"
                      name="messagePassword"
                      maxLength="50"
                      label="Gönderen E-Mail Şifresi"
                      value={this.state.messagePassword}
                      placeHolder="Lütfen gönderen e-mail şifresi girin..."
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.messagePasswordError}
                    />
                  </Col>
                </Row>
                {this.state.alertErrorMessage && (
                  <CgnAlert
                    color="danger"
                    title={CgnMessage.alertErrorTitle}
                    text={this.state.alertErrorMessage}
                  />
                )}
                <CgnButtonGroup items={this.state.buttons} />
              </Card>
            </Form>
            <CgnButtonLink
              color="secondary"
              to={"/"}
              text={CgnMessage.backButton}
              className="btn-back"
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default CompanyInfoUpdate;
